import React from "react";
import { ReactComponent as NoFoundImg } from "../../../assets/illustrations/404-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";
import { NavLink } from "react-router-dom";
import { SUPPORT_EMAIL } from "../../../constants";
import { ResendActivationForm } from "../../../components/forms/auth";

export const AuthLinkExpiredPage: React.FC = () => {
  return (
    <ServicesLayout image={<NoFoundImg />} title="This link has expired">
      <>
        <div className="text-base theme-text-secondary">
          Please request a new link below.
          <br />
          If have any issues please{" "}
          <NavLink to={`mailto:${SUPPORT_EMAIL}`} className="text-blue-500">
            contact customer support
          </NavLink>
          .
        </div>
        <div className="">
          <ResendActivationForm />
        </div>
      </>
    </ServicesLayout>
  );
};
